export default __webpack_public_path__ + "static/media/forgot_password_2.5cc0870d.png";